export default {
  init() {
    $.fn.exists = function() { return this.length > 0 }

    if($('.click-to-copy').exists()) ClickToCopy.init();

    $('li.menu-item-has-children').on('click', 'a', function() {
      $('li.menu-item-has-children').find('.sub-menu').stop().slideUp();
      $(this).closest('li.menu-item-has-children').find('.sub-menu').stop().slideToggle();
      //$(this).closest('li.menu-item-has-children').toggleClass('expanded');

      if ($(this).closest('li.menu-item-has-children').hasClass('current-menu-parent')) {
        $(this).closest('li.menu-item-has-children').removeClass('current-menu-parent');
        $('li.current-menu-parent').removeClass('current-menu-parent');
      } else {
        $('li.current-menu-parent').removeClass('current-menu-parent');
        $(this).closest('li.menu-item-has-children').toggleClass('current-menu-parent');
      }

      if(!$('li.menu-item-has-children').closest('li.menu-item-has-children').hasClass('current-menu-parent')) {
        $('li.current-menu-item').closest('li.menu-item-has-children').toggleClass('current-menu-parent');
        $('li.current-menu-item').closest('li.menu-item-has-children').find('.sub-menu').stop().slideToggle();

        $('li.current-category-ancestor').closest('li.menu-item-has-children').toggleClass('current-menu-parent');
        $('li.current-category-ancestor').closest('li.menu-item-has-children').find('.sub-menu').stop().slideToggle();

        $('.single-post li.current-post-ancestor').closest('li.menu-item-has-children').toggleClass('current-menu-parent');
        $('.single-post li.current-post-ancestor').closest('li.menu-item-has-children').find('.sub-menu').stop().slideToggle();
      }
    });

    $('header .menu-icon-button').on('click', function() {
      $('header .menu-icon-button .menu-icon').toggleClass('open');
      $('body').toggleClass('mobile-menu-open');
    });

    $('header .search-mobile').on('click', function() {
      $('header .mobile-search-wrapper').slideToggle();
    });

    $('.single-post li.current-post-ancestor').closest('li.menu-item-has-children').toggleClass('current-menu-parent');
    $('li.current-category-ancestor').closest('li.menu-item-has-children').toggleClass('current-menu-parent');

    $('.clear-filters').click(function() {
      $('#attachment_municipality').val('').change();
      $('#attachment_municipality').selectpicker('refresh');
      $('.filter-documents .submit-btn').trigger('click');
    });

    $('.filter-documents .submit-btn').click(function () {
      $('.loader-wrapper').show();
      $('.documents-items').hide();
      $('.doc-item-wrap').each(function () {
        $('.accordion-collapse').collapse('hide');
      });
      setTimeout(function() {
        $('.documents-items').show();
        $('.loader-wrapper').hide();
        var municipality = $('#attachment_municipality').val();
        console.log(municipality);
        if(municipality == '') {
          $('.clear-filters').hide();
        } else {
          $('.clear-filters').show();
        }
        $('.doc-item-wrap').each(function () {
            $('.accordion-collapse').collapse('hide');
            var municipality_item = $(this).data('municipality');
            if(municipality == municipality_item || municipality == '') {
              $(this).show();
            } else {
              $(this).hide();
            }
        });
      }, 1000);
    });

    if (location.hash) {
      var employee_element = location.hash;

      $(employee_element).addClass('active-employee');
    }

    $('#global-search, #global-search-mobile').on('keypress', function (e) {
      if (e.keyCode === 13) {
        var url = '/?s=' + $(this).val();
        window.location = url;
      }
    });

    $('.search .global-search-submit, .mobile-search-wrapper .search .global-search-submit').on('click', function () {
      var url = '/?s=' + $(this).parent().find('input').val();
      window.location = url;
    });

    $('#municipality-search').on('keypress', function (e) {
      if (e.keyCode === 13) {
        var url = '?search=' + $('#municipality-search').val();
        window.location = url;
      }
    });

    $('.municipalities-search .municipality-search-submit').on('click', function () {
      var url = '?search=' + $('#municipality-search').val();
      window.location = url;
    });

    $('.filter-employees .submit-btn').click(function(){
      var job_position = $('#employee_job_position').val();
      var department = $('#employee_department').val();
      var search = $('#employees-search').val();

      var url = '?job_position=' + job_position + '&department=' + department + '&search=' + search;
      window.location = url;
    })
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

var ClickToCopy = {
  init: function() {
    $('.click-to-copy input').on('click', function() {

      $(this).parent().addClass('in');

      var that = this;
      setTimeout(function() {
        $(that).parent().removeClass('in');
      }, 5000);

      $(this).select();
      document.execCommand('copy');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js